function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.9 4.5H2c-1.1 0-2 .9-2 2v6.9c0 1.1.9 2 2 2h9.9c1.1 0 2-.9 2-2V6.5c.1-1.1-.9-2-2-2zM2 5.6h9.9c.5 0 .9.4.9.9v5.8L9.9 9c-.5-.6-1.3-.6-1.8 0l-2.5 2.9-.9-1c-.5-.5-1.3-.5-1.7 0l-1.8 2V6.5c-.1-.5.3-.9.8-.9z"
});

function SvgPhoto(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 20"
  }, props), _ref);
}

export default SvgPhoto;